export default __webpack_public_path__ + "navigation-examples-embedded-navigation-thumbnail-v1-480-d2cb5fb0ead2f3087f7925f213125a75.webp";